// relative
import { apiSlice } from '../../apiSlice';

export const alarmGroupsApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['AlarmGroup'],
  endpoints: (builder) => ({
    getAlarmGroupsByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/AlarmGroups?orderby=AlarmGroupId&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['AlarmGroup'],
    }),
    getAlarmGroupById: builder.query({
      query: (alarmGroupId) => {
        return {
          url: `/AlarmGroups/${alarmGroupId}`,
        };
      },
      providesTags: (result, error, arg) => [{ type: 'AlarmGroup', id: arg }],
    }),
    postAlarmGroup: builder.mutation({
      query: (alarmGroup) => {
        return {
          url: `/AlarmGroups`,
          method: 'POST',
          body: alarmGroup,
        };
      },
      invalidatesTags: ['AlarmGroup', 'Alarm'],
    }),
    patchAlarmGroup: builder.mutation({
      query: (alarmGroup) => {
        return {
          url: `/AlarmGroups/${alarmGroup.AlarmGroupId}`,
          method: 'PATCH',
          body: alarmGroup,
        };
      },
      invalidatesTags: ['AlarmGroup', 'Alarm'],
    }),
    deleteAlarmGroup: builder.mutation({
      query: (alarmGroupId) => {
        return {
          url: `/AlarmGroups/${alarmGroupId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['AlarmGroup', 'Alarm'],
    }),
  }),
});

export const {
  useGetAlarmGroupsByAccountQuery,
  useGetAlarmGroupByIdQuery,
  usePostAlarmGroupMutation,
  usePatchAlarmGroupMutation,
  useDeleteAlarmGroupMutation,
} = alarmGroupsApiSlice;
